import '../css/pages/general-ranking.css';
import React, { useEffect, useState } from 'react';
import logoTrivia from '../assets/imagenes/logo-trivia.svg';
import axios from 'axios';
import { BASE_URL } from '../config/api';

const GeneralRanking = () => {
  const [generalRanking, setGeneralRanking] = useState([]);

  const listGeneralRanking = async () => {
    try {
      const response = await axios.post(`${BASE_URL}/general-ranking`);
      setGeneralRanking(response.data.data);
    } catch (error) {
      console.error('Error al cargar la clasificación general:', error);
    }
  };

  useEffect(() => {
    listGeneralRanking();
  }, []);

  return (
    <div className="container-general-ranking">
      <div>
        <img src={logoTrivia} alt="Logo de la trivia" />
      </div>

      <p className="general-ranking-title">Clasificación General</p>

      <div className="container-table-ranking">
        <table>
          <thead>
            <tr>
              <th>
                <div className="triangle"></div>
              </th>
              <th>PARTICIPANTE</th>
              <th>RESPUESTAS CORRECTAS</th>
              <th>TIEMPO</th>
              <th>PROMEDIO</th>
            </tr>
          </thead>

          <tbody>
            {generalRanking.map((player, index) => (
              <tr key={player.id ?? index}>
                <td>
                  <div className="container-id">{index + 1}</div>
                </td>
                <td>{player.name}</td>
                <td>{player.numberCorrectAnswers}</td>
                <td>{player.timeTakesRespond}</td>
                <td>{player.average}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GeneralRanking;